import React from "react";
import "./styles.css";
import "./carousel.css";
import "./overrides.css";
import Footer from "./Footer";
import Header from "./Header";
import ScrollToTop from "./ScrollToTop";

const Layout = ({ children }) => {
  return (
    <div className="dm-public-site min-h-screen flex flex-col">
      <ScrollToTop />
      <Header />
      <div className="content-scale flex-1 flex flex-col">
        <main className="flex-1">{children}</main>
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
